module.exports = __webpack_public_path__ + "img/logo1 (14).76a1be42.jpg";